import { render, staticRenderFns } from "./recordJi.vue?vue&type=template&id=a567bc6a&scoped=true&"
import script from "./recordJi.vue?vue&type=script&lang=js&"
export * from "./recordJi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a567bc6a",
  null
  
)

export default component.exports